import { Button, ChevronDownIcon } from '@mr-yum/frontend-ui'
import React, { useCallback } from 'react'
import { useIntl } from 'react-intl'

import { CartValidator } from '@/components/Cart/validation'
import { Address } from '@/components/Ordering/Address'
import { useSheetToggle } from '@/components/VenueV2/utils/sheetUtils'
import { useOrderingTypeContext } from '@/contexts/VenueOrderContext'
import { OrderingType } from '@/gql/graphql'
import { useLoggerLegacy } from '@/hooks/useLogger'

interface Props {
  cart?: CartValidator | null
  hasNoPaths?: boolean
}

export const AddressButton = ({ cart, hasNoPaths }: Props) => {
  const { logEventLegacy } = useLoggerLegacy()
  const sheetToggle = useSheetToggle()
  const intl = useIntl()

  const handleOnClick = useCallback(() => {
    logEventLegacy('Clicked on address selector')
    void sheetToggle({
      sheet: 'address',
    })
  }, [logEventLegacy, sheetToggle])

  const { orderingType } = useOrderingTypeContext()

  if (hasNoPaths) {
    return null
  }

  if (orderingType !== OrderingType.Delivery) {
    return null
  }

  return (
    <Button
      type="button"
      variant="link-primary"
      size="sm"
      onClick={handleOnClick}
      className="items-center gap-0"
      // eslint-disable-next-line formatjs/enforce-id
      aria-label={intl.formatMessage({
        defaultMessage: 'Select address',
        id: 'Ei5qD/',
      })}
      data-testid="select-address"
      rightIcon={
        <ChevronDownIcon width={20} height={20} className="flex-shrink-0" />
      }
    >
      {cart?.currentLocation ? (
        <Address className="text-left" location={cart?.currentLocation} />
      ) : (
        'Select address'
      )}
    </Button>
  )
}
